import { Box, Button, Card, Icon, Paper, Typography } from '@mui/material';
import queueImage from '../../../assets/images/landing/hero-5-img2.png';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';

const colors = {
    primary: "#d70001",//"#0066ff",//"#d70001",
    primaryBg: "#ffe6e6",//"#e6f0ff",//"#ffe6e6",
}

const commonStyles = {
    iconContainer: {
        my: 1,
        p: 1,
        mx: 'auto',
        backgroundColor: colors.primaryBg,
        width: 70,
        height: 70,
        borderRadius: 35,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}

const content = {
    "Health & Wellness": {
        title: "Health & wellness scheduling software to reduce admin work and grow your business",
        subTitle: "Streamline your center’s operations with wellness software that helps automate appointment scheduling, customer and therapist/doctor management, marketing, payments, and more!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            },
            {
                title: "Explore Demos ",
                subTitle: "Explore Demos",
                content: <Paper sx={{ py: 5, minHeight: '70vh' }} elevation={0} className=""  >
                    <Box sx={{ p: 5, textAlign: 'center' }}>
                        <Typography variant="h5" sx={{ p: 1, fontWeight: '700' }}>Explore Industry-Specific Demos</Typography>
                        <Typography variant="body" sx={{ opacity: 1 }}>Discover hands-on demos tailored for the Health & wellness segment.</Typography>
                    </Box>
                    <GridContainer justifyContent="center" >
                        <GridItem xs={12} md={10} lg={10} xl={8}>
                            <GridContainer justifyContent="center" >
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">Multi-Branch Hospital Group</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of a appointment system integrated on a multi-branch hospital group’s sample website using our Js library.  </Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open('https://cdn.que.zone/demo/hamad', '_blank')}>View Demo</Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">Spine Doctor</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of a appointment system integrated with Quezone for a doctor's website using our wordpress plugin.  </Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open('https://www.spinedoctorsrinivas.com/', '_blank')}>View Demo</Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">Demo Hospital</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of a appointment system for a hospital with a counter based OP service.  </Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open('https://testing.que.zone/hospital-demo', '_blank')}>View Demo</Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </Paper>
            },
        ]
    },
    "Fitness & Sports": {
        title: "Discover the easiest way to manage & grow your gym & fitness business",
        subTitle: "Quezone's fitness and gym scheduling software takes care of online booking, appointment reminders, trainer and facility management, marketing, payments, and more!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },
    "Professional Services": {
        title: "Save time, win new clients, and accelerate business growth with Quezone",
        subTitle: "Eliminate scheduling back-and-forth, manage client data, boost employee productivity, accept online payments, and automate marketing with our professional services software",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },
    "Salon & Beauty": {
        title: "All-in-one salon scheduling software to grow and manage your salon business",
        subTitle: "Quezone's salon booking software saves you time by automating appointment scheduling, salon management, marketing, payments, and much more!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },
    "Business Operations": {
        title: "Business Operations scheduling software to reduce admin work and grow your business",
        subTitle: "Streamline your center’s operations with wellness software that helps automate appointment scheduling, customer and therapist/doctor management, marketing, payments, and more!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            },
            {
                title: "Explore Demos ",
                subTitle: "Explore Demos",
                content: <Paper sx={{ py: 5, minHeight: '70vh' }} elevation={0} className=""  >
                    <Box sx={{ p: 5, textAlign: 'center' }}>
                        <Typography variant="h5" sx={{ p: 1, fontWeight: '700' }}>Explore Industry-Specific Demos</Typography>
                        <Typography variant="body" sx={{ opacity: 1 }}>Discover hands-on demos tailored for Business Operations segment.</Typography>
                    </Box>
                    <GridContainer justifyContent="center" >
                        <GridItem xs={12} md={10} lg={10} xl={8}>
                            <GridContainer justifyContent="center" >
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">LoggFi</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of appointment setup by an organization for their business operations and meetings  </Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open('https://testing.que.zone/loggfi/', '_blank')}>Check out</Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">Bagmo</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of appointment setup by an organization for their business operations and meetings  </Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open('https://que.zone/bagmo-private-limited', '_blank')}>Check out </Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </Paper>
            },
        ]
    },
    "Spa": {
        title: "All-in-one spa scheduling software to manage and grow your spa business",
        subTitle: "The best spa software and app with easy spa management, online scheduling, appointment reminders, marketing, payments, customer management, and more!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },
    "Education": {
        title: "Education scheduling software to reduce admin work, increase efficiency, and deliver better results",
        subTitle: "Save valuable teaching time with easy online appointments, class scheduling, student management, payments, automated reminders, and web conferencing!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },
    "Tutoring Services": {
        title: "#1 tutor scheduling software to run and grow your tutoring business",
        subTitle: "Free up time spent over calls/emails to schedule sessions and classes. Automate scheduling, reduce no shows, and run your tutoring business more efficiently",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },
    "Automotive": {
        title: "Automotive scheduling software to reduce admin work and grow your business",
        subTitle: "Streamline your center’s operations with wellness software that helps automate appointment scheduling, customer and therapist/doctor management, marketing, payments, and more!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            },
            {
                title: "Explore Demos ",
                subTitle: "Explore Demos",
                content: <Paper sx={{ py: 5, minHeight: '70vh' }} elevation={0} className=""  >
                    <Box sx={{ p: 5, textAlign: 'center' }}>
                        <Typography variant="h5" sx={{ p: 1, fontWeight: '700' }}>Explore Industry-Specific Demos</Typography>
                        <Typography variant="body" sx={{ opacity: 1 }}>Discover hands-on demos tailored for Automotive segment.</Typography>
                    </Box>
                    <GridContainer justifyContent="center" >
                        <GridItem xs={12} md={10} lg={10} xl={8}>
                            <GridContainer justifyContent="center" >
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">Used Car Showroom</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of our booking system for a used car showroom's website using an iframe container.  </Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open('https://gettecar.com', '_blank')}>View Demo</Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">Car Wash Service</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of our booking system  integrated for a Car & Bike Wash Service provider</Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open('https://cdn.que.zone/demo/carwash/index-1.html', '_blank')}>View Demo</Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </Paper>
            },
        ]
    },
    "Pet Services": {
        title: "Provide quality services your clients trust & their pets love!",
        subTitle: "Pet booking software with scheduling automation, marketing features, and inbuilt CRM to simplify admin tasks and personalize pet care experiences",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            },
            {
                title: "Explore Demos ",
                subTitle: "Explore Demos",
                content: <Paper sx={{ py: 5, minHeight: '70vh' }} elevation={0} className=""  >
                    <Box sx={{ p: 5, textAlign: 'center' }}>
                        <Typography variant="h5" sx={{ p: 1, fontWeight: '700' }}>Explore Industry-Specific Demos</Typography>
                        <Typography variant="body" sx={{ opacity: 1 }}>Discover hands-on demos tailored for Pet Services segment.</Typography>
                    </Box>
                    <GridContainer justifyContent="center" >
                        <GridItem xs={12} md={10} lg={10} xl={8}>
                            <GridContainer justifyContent="center" >
                                <GridItem xs={12} sm={12} md={6} lg={3} >
                                    <Card sx={{
                                        p: 2, mx: 1, my: 5, textAlign: 'center',
                                        borderRadius: 3,
                                        animation: 'fadeInFromRight 0.25s ease-out', // Adjust the duration and easing function as needed
                                        '@keyframes fadeInFromRight': {
                                            from: { opacity: 0, transform: 'translateX(100%)' },
                                            to: { opacity: 1, transform: 'translateX(0%)' },
                                        },
                                    }}>
                                        <Box sx={commonStyles.iconContainer}>
                                            <Icon sx={{ fontSize: 35, color: colors.primary }}>launch</Icon>
                                        </Box>
                                        <Typography variant="overline">Pet Grooming Service</Typography>
                                        <Box>
                                            <Typography variant="caption" sx={{ color: "text.secondary" }}>This is an example of our booking system  integrated for a Pet Grooming Service provider</Typography>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" size="samll" sx={{ mt: 5, borderRadius: 3 }} onClick={() => window.open("https://que.zone/hooman's-pet-stories", '_blank')}>View Demo</Button>
                                        </Box>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </Paper>
            },
        ]
    },
    "Government & Public Sector": {
        title: "Automate daily operations to save time & serve citizens better with fast, frictionless experiences",
        subTitle: "Our appointment booking software helps public offices optimize their front desk as well as back-office processes which boosts employee productivity and citizen satisfaction",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },
    "Home Services & Cleaning": {
        title: "Avoid messy schedules & book more with Quezone!",
        subTitle: "Cleaning booking software that takes care of your business with scheduling automation, efficient cleaner management, advanced marketing suite, & much more!",
        titleImage: queueImage,
        sections: [
            {
                title: "title ",
                subTitle: "subTitle",
                content: ""
            }
        ]
    },

}

export default content;